import { FC } from 'react';
import { ResourcesOption } from '../../types';
import { Popup } from '@getsynapse/design-system';
import ResourcesList from './ResourcesList';
import ResourceButton from '../Footer/ResourceButton';

interface ResourcesPopupProps {
  resourcesOptions: ResourcesOption[];
  isExpanded: boolean;
}

const ResourcesPopup: FC<ResourcesPopupProps> = ({
  resourcesOptions,
  isExpanded,
}) => {
  return (
    <Popup
      trigger={({ isOpen }) => (
        <ResourceButton isExpanded={isExpanded} isActive={isOpen} />
      )}
      triggerProps={{
        className: 'max-w-full',
      }}
      popperProps={{
        className: 'rounded z-20',
        id: 'resources-menu',
        role: 'menu',
        'aria-label': 'Resources menu',
      }}
      position='right-end'
    >
      {({ close }) => (
        <ResourcesList
          resourcesOptions={resourcesOptions}
          onSelectOption={() => close()}
        />
      )}
    </Popup>
  );
};

export default ResourcesPopup;
